import type { MaasSharedFormValues } from '@/delivery-type-plugin/capabilities/maas-init/maasTypes';
import {
  getDataDiskMode,
  parsePrimaryDataVolumeField,
  resolvePrimaryDataVolumeFromValues,
} from '@/delivery-type-plugin/capabilities/maas-node-groups/masterGroupForm';

/**
 * SKU 预置是否已配置模型与存储。
 * 预置存的是表单值；兼容 `_primaryDataVolume` / 组内 Data 卷 / model 字段。
 */
export function hasPresetModelStorage(preset?: Record<string, unknown> | null): boolean {
  if (!preset) return false;

  const fromValues = resolvePrimaryDataVolumeFromValues(
    preset as Pick<MaasSharedFormValues, 'runMode' | 'headGroupSpec' | 'workerGroupSpecs' | '_primaryDataVolume'>,
  );
  const fromField = parsePrimaryDataVolumeField(preset._primaryDataVolume);
  const maasForm = preset.maasForm as { primaryDataVolume?: unknown } | undefined;
  const fromMaasForm = parsePrimaryDataVolumeField(maasForm?.primaryDataVolume);
  const volume = fromValues || fromField || fromMaasForm;
  if (volume && getDataDiskMode(volume)) return true;

  const model = preset.model as Record<string, unknown> | undefined;
  if (model && typeof model === 'object' && !Array.isArray(model)) {
    const sources = model.sources;
    if (Array.isArray(sources) && sources.length > 0) return true;
  }

  return false;
}
